import { CKButton } from 'clearkit';

import useDeveloperOverride from '~/hooks/account/useDeveloperOverride';
import useFeatureFlag from '~/hooks/account/useFeatureFlag';

export default function TableRow({ flag }) {
  const override = useDeveloperOverride(`FEATURE_FLAG:${flag}`);
  const flagState = useFeatureFlag(flag);
  return (
    <tr>
      <td className="px-6 py-4 text-sm font-medium text-gray-900 whitespace-nowrap">
        <pre>{flag}</pre>
      </td>
      <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
        <pre>{JSON.stringify(flagState.enabled)}</pre>
      </td>
      <td className="px-6 py-4 text-sm text-gray-500 whitespace-nowrap">
        <pre>{JSON.stringify(override.isOverridden)}</pre>
      </td>
      <td className="px-6 py-4 text-sm font-medium">
        <CKButton
          isDisabled={!override.isOverridden}
          onClick={() => {
            override.clearOverride();
          }}>
          Clear Override
        </CKButton>
      </td>
      <td className="px-6 py-4 text-sm font-medium">
        <CKButton
          onClick={() => {
            override.setOverrideValue(true);
          }}>
          Override True
        </CKButton>
      </td>
      <td className="px-6 py-4 text-sm font-medium">
        <CKButton
          onClick={() => {
            override.setOverrideValue(false);
          }}>
          Override False
        </CKButton>
      </td>
    </tr>
  );
}
